export default __webpack_public_path__ + "static/media/sirolaser-direkt-danach.d6361f04.jpg";